<template>
  <p class="drawerLink" @click.stop="() => navigate(`/module/${module[0]}${params}`)"><img :src="module[1].icons.drawer">{{ module[1].name[$i18n.locale] }}</p>
</template>

<script>
export default {
    props: ['module'],
    computed: {
        params(){
            if(this.module[1].params){
                return '/' + this.module[1].params.join('/')
            }
            else {
                return ''
            }
        }
    },
    methods: {
        navigate(route){
            this.$emit('close')
            if(this.$route.path != route){
                this.$router.pushWithEvent(route)
            }
        }
    }
}
</script>

<style>

</style>